import { Ignore } from '@master/annotation/Ignore'
import { TypeBase } from '@master/model/TypeBase'
import { IDateService } from '@master/services/IDateService'
import { inject } from 'inversify-props'

export class ClientProductILPSP extends TypeBase {
  @Ignore()
  @inject()
  protected dateService: IDateService

  constructor (idx: number) {
    super(`ilp_${idx}_single`)
  }

  name = ''
  amt = undefined
  approvedDate = undefined
  unitBalance = undefined
  riskClass = undefined
  cash = undefined
  stock = undefined
  bonds = undefined

  afterExtractData (data) {
    data.unitBalance = Number(data.unitBalance)
    data.premium = Number(data.premium)
    data.cash = Number(data.cash)
    data.stock = Number(data.stock)
    data.bonds = Number(data.bonds)
    // existing data store date string
    data.approvedDate = new Date(data.approvedDate)?.getTime()
    return data
  }

  formattedDate (unixTime: number | string) {
    return this.dateService.format(Number(unixTime), 'YYYY-MM-DD')
  }

  convertToRawData () {
    const raw = super.convertToRawData()
    // special handling to store the date as string ( existing data )
    raw[this.snakeCaseKey('approvedDate')] = this.formattedDate(raw[this.snakeCaseKey('approvedDate')])
    return raw
  }
}
